import config from '../../android/app/src/qvs/debug/google-services.json';

export const firebaseConfig = {
  apiKey: config.client[0].api_key[0].current_key,
  authDomain: config.project_info.firebase_url,
  projectId: config.project_info.project_id,
  storageBucket: config.project_info.storage_bucket,
  messagingSenderId: config.project_info.project_number,
  appId: config.client[0].client_info.mobilesdk_app_id,
  remoteConfig: {
    minimumFetchIntervalMillis: 360000
  }
};
